"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TransformSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6,6 L6,4 L7,4 L7,6 L11,6 C12.1045695,6 13,6.8954305 13,8 L13,12 L15,12 L15,13 L13,13 L13,15 L12,15 L12,13 L8,13 C6.8954305,13 6,12.1045695 6,11 L6,7 L4,7 L4,6 L6,6 Z M12,12 L12,8 C12,7.44771525 11.5522847,7 11,7 L7,7 L7,11 C7,11.5522847 7.44771525,12 8,12 L12,12 Z M16,9.5 C16,6.64147959 14.4008209,4.15646749 12.0483077,2.89080878 L10.5,4 L9,1.01446179 C13.4616897,1.27327069 17,4.97342702 17,9.5 C17,9.6678474 16.995135,9.8345585 16.9855382,10 L15.9835977,10 C15.9944753,9.83473819 16,9.66801428 16,9.5 Z M2,9.51446179 C2,12.3729822 3.59917914,14.8579943 5.95169232,16.123653 L7.5,15.0144618 L9,18 C4.53831026,17.7411911 1,14.0410348 1,9.51446179 C1,9.34661439 1.00486504,9.17990329 1.01446179,9.01446179 L2.01640228,9.01446179 C2.00552468,9.1797236 2,9.34644751 2,9.51446179 Z" })));
};
TransformSmall.displayName = 'TransformSmall';
exports.default = TransformSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TransformSmall.js.map